import { StaticImageData } from 'next/image'

/**
 * Returns the URL of an imported static image.
 *
 * Webpack resolves image imports to a `StaticImageData` object while
 * Turbopack resolves them to the URL string, so both shapes are accepted.
 */
export default function getStaticImageSrc(
  image: string | StaticImageData,
): string {
  return typeof image === 'string' ? image : image.src
}
